import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import styles from "./ShowReels.module.css";

const ShowReels = () => {
  const containerRef = useRef(null);

  // Scroll Progress Hook
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end center"],
  });

  // Mask Clip Animation (Reveals Text)
  const maskClip = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  // Parallax Effect for Video
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0px", "-100px"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.2]);

  return (
    <div className={styles.showReelsContainer} ref={containerRef}>
      <motion.div
        className={styles.showReelsContent}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Upper Show Reel Text with Mask Reveal Effect */}
        <motion.h1
          className={styles.showReelUpper}
          style={{
            WebkitMaskImage: `linear-gradient(to bottom, black ${maskClip.get()}, transparent)`,
            maskImage: `linear-gradient(to bottom, black ${maskClip.get()}, transparent)`,
          }}
        >
          Show Reels
        </motion.h1>

        <div className={styles.videowrapper}>
          {/* Parallax Video Effect */}
          <video
            className={styles.showreelVideo}
            src="https://studiomaamangala.com/wp-content/uploads/2025/02/WEB.webm"
            preload="auto"
            autoPlay
            loop
            muted
            playsInline
            style={{ y: parallaxY, scale }}
          />
          <div className={styles.connectArrow}></div>
        </div>

        {/* Bottom Show Reel Text with Opposite Mask Reveal */}
        <motion.h1
          className={styles.showReelBottom}
          style={{
            WebkitMaskImage: `linear-gradient(to top, black ${maskClip.get()}, transparent)`,
            maskImage: `linear-gradient(to top, black ${maskClip.get()}, transparent)`,
          }}
        >
          Show Reels
        </motion.h1>
      </motion.div>
    </div>
  );
};

export default ShowReels;
